let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e8T2Z")).then(() => parcelRequire('gLJdb'));